"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_shared_js_1 = require("@tableau/api-shared-js");
const InitializationServiceImpl_1 = require("./Impl/InitializationServiceImpl");
const ToolbarServiceImpl_1 = require("./Impl/ToolbarServiceImpl");
function registerAllEmbeddingServices(dispatcher, registryId) {
    const registry = api_shared_js_1.ApiServiceRegistry.get(registryId);
    registry.registerService(new api_shared_js_1.ClientInfoServiceImpl(dispatcher, registryId));
    registry.registerService(new api_shared_js_1.SizeServiceImpl(dispatcher, registryId));
    registry.registerService(new api_shared_js_1.StoryActivationServiceImpl(dispatcher, registryId));
    registry.registerService(new ToolbarServiceImpl_1.ToolbarServiceImpl(dispatcher, registryId));
}
exports.registerAllEmbeddingServices = registerAllEmbeddingServices;
function registerInitializationEmbeddingServices(dispatcher, registryId) {
    api_shared_js_1.ApiServiceRegistry.get(registryId).registerService(new InitializationServiceImpl_1.InitializationServiceImpl(dispatcher));
}
exports.registerInitializationEmbeddingServices = registerInitializationEmbeddingServices;
//# sourceMappingURL=RegisterAllEmbeddingServices.js.map